<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import type { AccessibleOrganization } from '@/types/organization';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
    organization: AccessibleOrganization;
    menuOpenId: string;
}>();

const authStore = useAuthStore();
const router = useRouter();

const menuOpenIds = ref<string[]>([]);

function selectOrg(organization: AccessibleOrganization) {
    if (!organization) return;
    authStore.currentOrganization = organization;
    router.push({ path: '/dashboard', replace: true });
}

function toggleChildMenu(id: string) {
    if (!menuOpenIds.value.includes(id)) {
        menuOpenIds.value.push(id);
    } else {
        menuOpenIds.value = menuOpenIds.value.filter((o) => o !== id);
    }
}
</script>

<template>
    <v-virtual-scroll v-if="props.menuOpenId === props.organization._id" class="pa-0 px-2 bg-grey-light" :items="props.organization.children">
        <template v-slot:default="{ item: org }">
            <v-list-item class="py-0" @click="selectOrg(org)">
                <span :class="{ 'font-weight-bold text-main': authStore.currentOrganization?._id === org._id }">{{ org.name }}</span>
                <v-icon
                    :icon="menuOpenIds.includes(org._id) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                    class="hover-main text-main font-weight-bold ml-2"
                    v-if="org.children && org.children?.length > 0"
                    @click.stop="toggleChildMenu(org._id)"
                />
            </v-list-item>
            <RecursiveOrganizationMenu :organization="org" :menuOpenId="menuOpenIds.includes(org._id) ? org._id : ''" />
        </template>
    </v-virtual-scroll>
</template>

<style scoped></style>
